import React from 'react';
import { Award, Shield, Users } from 'lucide-react';
import { lawyerData, images } from '../data/mock';
import { useParallaxInView, useParallaxSimple } from '../hooks/useParallax';

export const AboutSection = () => {
  const { ref: textRef, style: textParallax } = useParallaxInView(0.04);
  const decorParallax = useParallaxSimple(0.06);

  const valueIcons = {
    'Ética profissional': Shield,
    'Sigilo absoluto': Shield,
    'Comprometimento com o cliente': Users,
    'Transparência na comunicação': Award
  };

  const lawyerPhoto = images.aboutPhoto || lawyerData.about?.photo || images.lawyerPhoto;

  return (
    <section id="sobre" className="py-16 sm:py-20 lg:py-24 bg-white relative overflow-hidden">
      <div
        className="absolute -top-20 right-0 w-64 h-64 sm:w-80 sm:h-80 rounded-full bg-[#d4af37]/5 blur-3xl pointer-events-none"
        style={decorParallax.style}
        aria-hidden
      />

      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-10 sm:mb-14">
          <span className="inline-block text-[#b8962e] text-xs sm:text-sm font-semibold tracking-widest uppercase mb-3 sm:mb-4">
            {lawyerData.about?.title || 'Conheça a Dra.'}
          </span>
          <h2 className="font-serif text-2xl sm:text-3xl md:text-4xl text-[#0f1f3d] leading-tight max-w-2xl mx-auto tracking-tight">
            {lawyerData.about?.sectionHeadline || 'Conheça a profissional que vai cuidar do seu caso'}
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,0.92fr)_minmax(0,1.08fr)] gap-10 sm:gap-12 lg:gap-14 xl:gap-16 items-stretch">
          <div className="order-2 lg:order-1">
            <div className="relative h-full min-h-[280px] overflow-hidden rounded-2xl border border-slate-200/80 bg-white shadow-lg sm:min-h-[400px] aspect-[3/4] sm:aspect-auto">
              <img
                src={lawyerPhoto}
                alt={`${lawyerData.name} - Advogada`}
                className="absolute inset-0 h-full w-full scale-x-[-1] object-cover object-[68%_10%]"
              />
            </div>
          </div>

          <div className="order-1 lg:order-2" ref={textRef} style={textParallax.style}>
            <h3 className="font-serif text-2xl sm:text-3xl md:text-[2rem] text-[#0f1f3d] leading-tight mb-6 tracking-tight">
              {lawyerData.name}
            </h3>

            <div className="space-y-5 mb-8 sm:mb-10">
              {(lawyerData.about?.paragraphs || []).map((paragraph, index) => (
                <p key={index} className="text-slate-600 leading-relaxed text-sm sm:text-base">
                  {paragraph}
                </p>
              ))}
            </div>

            <div>
              <h4 className="font-serif text-lg sm:text-xl font-semibold text-[#0f1f3d] mb-4">
                Pilares do atendimento
              </h4>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                {lawyerData.about.values.map((value, index) => {
                  const Icon = valueIcons[value] || Shield;
                  return (
                    <div
                      key={index}
                      className="flex items-center gap-3 p-4 bg-white rounded-xl border border-slate-200/90"
                    >
                      <div className="w-10 h-10 rounded-lg bg-[#f5f1ed] flex items-center justify-center flex-shrink-0 border border-[#d4af37]/20">
                        <Icon size={20} className="text-[#b8962e]" />
                      </div>
                      <span className="text-sm sm:text-base font-medium text-slate-700 leading-snug">
                        {value}
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
